export const listEntities = (state) => state.listEntities;
export const loading = (state) => state.loading;
export const fieldEntities = (state) => state.fieldEntities;
export const pagination = (state) => (state.pagination);
